module.exports = __webpack_public_path__ + "static/coupon-en-5a44a368d94682b6c77d805f29967f76.png";